webpackJsonp([1],{

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inscricao_vue__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_843bcfd8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inscricao_vue__ = __webpack_require__(723);
var normalizeComponent = __webpack_require__(38)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inscricao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_843bcfd8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inscricao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    strict: true,
    state: {
        loggedIn: false,
        loaded: false,
        evento_id: 26,
        user: false,
        cart: false,
        inscricao: false,
        evento: false,
        produtos: false,
        compras: false,
        inscricaoIniciada: false,
        requiredProducts: false,
        inscricaoOk: false,
        ended: false
    },
    mutations: {
        addToCart: function addToCart(state, payload) {
            state.cart.push(payload);
        },
        removeFromCart: function removeFromCart(state, payload) {
            for (var i in state.cart) {
                if (state.cart[i].product === payload.product) {
                    state.cart.splice(i, 1);
                }
            }
        },
        logout: function logout(state) {
            state.produtos = state.compras = state.user = state.loggedIn = false;
            __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.remove('bearer');
        },

        assignInfo: function assignInfo(state, payload) {
            state.produtos = payload.produtos;
            state.compras = payload.compras;
            state.user = payload.user;
            state.cart = payload.cart;
            state.loggedIn = true;
            state.inscricaoIniciada = payload.inscricaoIniciada;
            state.requiredProducts = payload.requiredProducts;
            state.inscricaoOk = payload.inscricaoOk;
        },
        assignData: function assignData(state, payload) {
            state.inscricao = payload.inscricao;
            state.evento = payload.evento;
            if (!state.voucherOnly) {
                state.ended = payload.ended;
            } else {
                state.ended = false;
            }
            state.loaded = true;
        }
    },
    actions: {
        login: function login(context, payload) {
            if (payload.token) {
                __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('bearer', payload.token);
            }

            var bearerToken = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('bearer');

            return __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.ajax({
                url: "https://inscricoes.horadecorrer.com/frontend/info",
                method: 'GET',
                error: function error(data, textStatus, jqXHR) {
                    toastr.error('Erro obtendo informações do servidor');
                },
                dataType: 'JSON',
                headers: {
                    'Authorization': 'Bearer ' + bearerToken
                }
            });
        },
        loadData: function loadData(context) {
            return __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.ajax({
                url: "https://inscricoes.horadecorrer.com/site/skel",
                method: 'GET',
                data: {
                    evento_id: context.state.evento_id
                },
                error: function error(data, textStatus, jqXHR) {
                    toastr.error('Erro obtendo informações para a inscrição');
                },
                dataType: 'JSON'
            });
        }
    }
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(53)))

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(349);
module.exports = __webpack_require__(551);


/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_v_mask__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(346);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_v_mask__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
    }
});

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_498d63e9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(561);
function injectStyle (ssrContext) {
  __webpack_require__(554)
}
var normalizeComponent = __webpack_require__(38)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_498d63e9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 554:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_sass__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Navbar__ = __webpack_require__(558);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            brand: 'FESTIVAL PÉ NA PRAIA - São Miguel do Gostoso (Beach Tennis)'
        };
    },
    components: {
        Navbar: __WEBPACK_IMPORTED_MODULE_1__components_Navbar__["a" /* default */]
    },
    created: function created() {
        var diz = this;
        this.$store.dispatch('loadData').then(function (data, textStatus, jqXHR) {
            diz.$store.commit('assignData', data);
        });
    },
    mounted: function mounted() {
        document.title = this.brand;
    }
});

/***/ }),

/***/ 558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e53199e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__(560);
var normalizeComponent = __webpack_require__(38)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e53199e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        brand: {
            'default': 'Mude-me'
        }
    }
});

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hesllo"},[_c('nav',{staticClass:"navbar navbar-default"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.brand))])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbar"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[(_vm.$store.state.loggedIn)?[_c('router-link',{attrs:{"tag":"li","to":"/logout"}},[_c('a',[_vm._v("Sair")])])]:[_c('router-link',{attrs:{"tag":"li","to":"/login"}},[_c('a',[_vm._v("Login")])])]],2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle collapsed",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbar","aria-expanded":"false"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Alternar menu")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navbar',{attrs:{"brand":_vm.brand}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Senha__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NovaSenha__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_toastr__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_cookie__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_js_cookie__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    linkActiveClass: 'active',
    store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
    routes: [{
        path: '/',
        name: 'Hello',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */]
    }, {
        path: '/login',
        name: 'Login',
        component: __WEBPACK_IMPORTED_MODULE_3__components_Login__["a" /* default */],
        beforeEnter: function beforeEnter(to, from, next) {
            if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].loggedIn) {
                __WEBPACK_IMPORTED_MODULE_7_toastr___default.a.info('Você já está logado.');
                next('/');
            } else {
                next();
            }
        }
    }, {
        path: '/senha',
        name: 'Senha',
        component: __WEBPACK_IMPORTED_MODULE_4__components_Senha__["a" /* default */],
        beforeEnter: function beforeEnter(to, from, next) {
            if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].loggedIn) {
                __WEBPACK_IMPORTED_MODULE_7_toastr___default.a.info('Você já está logado.');
                next('/');
            } else {
                next();
            }
        }
    }, {
        path: '/novasenha/:token/:email',
        name: 'Nova Senha',
        component: __WEBPACK_IMPORTED_MODULE_5__components_NovaSenha__["a" /* default */],
        beforeEnter: function beforeEnter(to, from, next) {
            if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].loggedIn) {
                __WEBPACK_IMPORTED_MODULE_7_toastr___default.a.info('Você já está logado.');
                next('/');
            } else {
                next();
            }
        }
    }, {
        path: '/logout',
        name: 'Logout',
        beforeEnter: function beforeEnter(to, from, next) {
            __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('logout');
            __WEBPACK_IMPORTED_MODULE_7_toastr___default.a.info('Você saiu do sistema.');
            next('/');
        }
    }]
});

router.beforeEach(function (to, from, next) {
    if (to.name !== 'Logout') {
        var bearerToken = __WEBPACK_IMPORTED_MODULE_8_js_cookie___default.a.get('bearer');
        if (bearerToken) {
            __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('login', { token: bearerToken }).then(function (data, textStatus, jqXHR) {
                if (data) {
                    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('assignInfo', data);
                }
            });
        }
    }
    next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_030db0c1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(734);
var normalizeComponent = __webpack_require__(38)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_030db0c1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Inscricao__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Painel__ = __webpack_require__(725);





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Inscricao: __WEBPACK_IMPORTED_MODULE_0__Inscricao__["a" /* default */],
        Painel: __WEBPACK_IMPORTED_MODULE_1__Painel__["a" /* default */]
    }
});

/***/ }),

/***/ 566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cep_promise__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cep_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cep_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);






var throttle = __webpack_require__(712);
var CPF = __webpack_require__(713).CPF;
var moment = __webpack_require__(0);
var slugify = __webpack_require__(95);
moment.locale('pt-BR');
var vex = __webpack_require__(717);
vex.defaultOptions.className = 'vex-theme-default';
var validaCpf = function validaCpf(val) {
    if (val === '') return true;
    return CPF.isValid(val);
};
var acdInfo = '\n    <p>De acordo com a Lei 12.933/2013 o atleta deve apresentar a documenta\xE7\xE3o necess\xE1ria a comprova\xE7\xE3o da defici\xEAncia: Laudo T\xE9cnico emitido pela CORDE e o Laudo M\xE9dico que originou o enquadramento como PCD.</p>\n    <p>A CORDE \xE9 um \xF3rg\xE3o vinculado a Secretaria Estadual da Justi\xE7a e da Cidadania - SEJUC, que trata das pol\xEDticas p\xFAblicas voltadas exclusivamente \xE0s pessoas com defici\xEAncia no Estado do Rio Grande do Norte.</p>\n';

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['editMode'],
    data: function data() {
        return {
            currentIdadeMinima: 18,
            idadeMinima: 14,
            idade5: 14,
            idade10: 16,
            idadeAdulto: 18,
            sending: false,
            errors: false,
            aceito: false,
            aceitoVacina: false,
            loadingCep: false,
            maskCpf: '###.###.###-##',
            telefoneMask: '',
            celularMask: '',
            fixedCelularMask: '(##) #####-####',
            documentoMask: '',
            documentoLabel: '',
            inscricao: {
                email: '',
                login: '',
                senha: '',
                confirma_senha: '',
                nome: '',
                documento: '',
                documento_tipo: 'CPF',
                telefone: '',
                celular: '',
                nascimento: '',
                especial: '',
                cep: '',
                logradouro: '',
                numero: '',
                complemento: '',
                bairro: '',
                cidade: '',
                uf: 'RN',
                metadados: {
                    camiseta: '',
                    equipe: '',
                    categoria: '',

                    atleta2_nome: '',
                    atleta2_cpf: '',
                    atleta2_email: '',
                    atleta2_celular: '',
                    atleta2_camiseta: ''
                }
            }

        };
    },
    mounted: function mounted() {
        this.adjustDocumentoField();
        if (this.$store.state.ended && !sessionStorage.getItem('popupShown')) {
            sessionStorage.setItem('popupShown', '1');
            var encerradoInfo = '\n                    <div style="padding: 4rem">\n                        <h2>Inscri\xE7\xF5es encerradas.</h2>\n                        <p>Maiores informa\xE7\xF5es: <a href="mailto:contato@hcsports.com.br">contato@hcsports.com.br</a></p>\n                    </div>\n                ';
            vex.dialog.alert({ unsafeMessage: encerradoInfo });
        }
    },
    methods: {
        showAcd: function showAcd(evt) {
            evt.preventDefault();
            vex.dialog.alert({ unsafeMessage: acdInfo });
        },
        getIdade: function getIdade(val) {
            return moment('31-12-' + new Date().getFullYear(), 'DD-MM-YYYY').diff(moment(val, 'DD-MM-YYYY'), 'years');
        },
        inscricaoSave: function inscricaoSave(evt) {
            evt.preventDefault();
            this.inscricao.evento_id = this.$store.state.evento_id;
            this.sending = true;
            var diz = this;
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
                url: "https://inscricoes.horadecorrer.com/site/create",
                method: 'POST',
                data: this.inscricao,
                success: function success(data, textStatus, jqXHR) {
                    diz.$store.dispatch('login', { token: data.access_token }).then(function (data, textStatus, jqXHR) {
                        diz.$store.commit('assignInfo', data);
                    });
                    __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.success('Seus dados foram salvos.');
                },
                error: function error(data, textStatus, jqXHR) {
                    __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.error(data.responseText);
                },
                complete: function complete(data, textStatus, jqXHR) {
                    diz.sending = false;
                },
                dataType: 'JSON'
            });
        },
        formGroupClass: function formGroupClass($v) {
            for (var i in arguments) {
                if (typeof arguments[i] !== 'string') {
                    continue;
                }
                var isMetadados = arguments[i].indexOf('.');
                var el;
                if (isMetadados >= 0) {
                    el = $v.inscricao.metadados[arguments[i].substr(isMetadados + 1)];
                } else {
                    el = $v.inscricao[arguments[i]];
                }

                if (el.$error) {
                    return 'has-error';
                } else if (el.$dirty && !el.$error) {
                    return 'has-success';
                }
            }
            return false;
        },
        adjustDocumentoField: function adjustDocumentoField() {
            if (this.inscricao.documento_tipo === 'CPF') {
                this.documentoLabel = 'CPF';
                this.documentoMask = '###.###.###-##';
            } else {
                this.documentoLabel = 'Passaporte';
                this.documentoMask = '';
            }
        },
        setMaskedFieldState: function setMaskedFieldState($v, field) {
            if (this.inscricao[field].length) {
                $v.inscricao[field].$touch();
            }
        },
        throttledCep: throttle(function (val) {
            this.loadingCep = true;
            var diz = this;
            __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.info('Carregando informações para o CEP ' + val + '.');
            __WEBPACK_IMPORTED_MODULE_1_cep_promise___default()(val).then(function (data) {
                __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.success('Informações obtidas com sucesso.');
                diz.loadingCep = false;

                diz.inscricao.uf = data.state;
                diz.inscricao.cidade = data.city;
                diz.inscricao.bairro = data.neighborhood;
                diz.inscricao.logradouro = data.street;
                diz.$v.inscricao.cidade.$touch();
                diz.$v.inscricao.bairro.$touch();
                diz.$v.inscricao.logradouro.$touch();

                document.getElementById('numero').focus();
            }, function () {
                diz.loadingCep = false;
                __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.error('Não foi possível carregar as informações do CEP.');
                __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.warning('Por favor, informe seu endereço manualmente.');
            });
        }, 3000)
    },
    watch: {
        'inscricao.login': function inscricaoLogin(val) {
            this.inscricao.login = slugify(val.toLowerCase(), '.').replace('..', '.');
        },
        'inscricao.email': function inscricaoEmail(val) {
            this.inscricao.email = val.toLowerCase();
        },
        'inscricao.nome': function inscricaoNome(val) {
            this.inscricao.nome = val.toUpperCase().replace('  ', ' ');
        },
        'inscricao.logradouro': function inscricaoLogradouro(val) {
            this.inscricao.logradouro = val.toUpperCase().replace('  ', ' ');
        },
        'inscricao.numero': function inscricaoNumero(val) {
            this.inscricao.numero = val.toUpperCase().replace('  ', ' ');
        },
        'inscricao.complemento': function inscricaoComplemento(val) {
            this.inscricao.complemento = val.toUpperCase().replace('  ', ' ');
        },
        'inscricao.bairro': function inscricaoBairro(val) {
            this.inscricao.bairro = val.toUpperCase().replace('  ', ' ');
        },
        'inscricao.cidade': function inscricaoCidade(val) {
            this.inscricao.cidade = val.toUpperCase().replace('  ', ' ');
        },
        'inscricao.documento_tipo': function inscricaoDocumento_tipo(val) {
            this.adjustDocumentoField();
        },
        'inscricao.telefone': function inscricaoTelefone(val) {
            if (this.inscricao.telefone.length <= 14) {
                this.telefoneMask = '(##) ####-#####';
            } else {
                this.telefoneMask = '(##) #####-####';
            }
        },
        'inscricao.celular': function inscricaoCelular(val) {
            if (this.inscricao.celular.length <= 14) {
                this.celularMask = '(##) ####-#####';
            } else {
                this.celularMask = '(##) #####-####';
            }
        },
        'inscricao.cep': function inscricaoCep(val) {
            if (!this.$v.inscricao.cep.$error) {
                this.throttledCep(val);
            }
        },
        'inscricao.metadados.equipe': function inscricaoMetadadosEquipe(val) {
            this.inscricao.metadados.equipe = val.toUpperCase().replace('  ', ' ');
        },
        'inscricao.metadados.atleta2_nome': function inscricaoMetadadosAtleta2_nome(val) {
            this.inscricao.metadados.atleta2_nome = val.toUpperCase().replace('  ', ' ');
        },
        'inscricao.metadados.atleta3_nome': function inscricaoMetadadosAtleta3_nome(val) {
            this.inscricao.metadados.atleta3_nome = val.toUpperCase().replace('  ', ' ');
        },
        'inscricao.metadados.atleta4_nome': function inscricaoMetadadosAtleta4_nome(val) {
            this.inscricao.metadados.atleta4_nome = val.toUpperCase().replace('  ', ' ');
        },
        'inscricao.metadados.atleta5_nome': function inscricaoMetadadosAtleta5_nome(val) {
            this.inscricao.metadados.atleta5_nome = val.toUpperCase().replace('  ', ' ');
        },
        'inscricao.metadados.atleta6_nome': function inscricaoMetadadosAtleta6_nome(val) {
            this.inscricao.metadados.atleta6_nome = val.toUpperCase().replace('  ', ' ');
        }
    },
    validations: {
        semMulheresSuficientes: {
            mulheres: function mulheres(val) {
                return val !== true;
            }
        },
        aceito: {
            required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
        },
        aceitoVacina: {
            required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
        },
        inscricao: {
            login: {
                required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
            },
            email: {
                required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
                email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"],
                maxLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(60)
            },
            senha: {
                required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
                minLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(4)
            },
            confirma_senha: {
                sameAs: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["sameAs"])('senha')
            },
            nome: {
                required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
                maxLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(50),
                containsSpace: function containsSpace(val) {
                    if (val === '') return true;
                    return !!val.match(/\S+\s\S+/);
                }
            },
            documento: {
                required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
                cpf: function cpf(val) {
                    if (val === '') return true;
                    if (this.inscricao.documento_tipo === 'CPF') {
                        return CPF.isValid(val);
                    }
                    return true;
                }
            },
            telefone: {
                minLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(14)
            },
            celular: {
                required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
                minLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(14)
            },
            nascimento: {
                required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
                minLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(10),
                data: function data(val) {
                    if (val === '') return true;
                    if (val.length === 10) {
                        var m = moment(val, 'DD-MM-YYYY');
                        return m.isValid();
                    }
                    return false;
                },
                idade: function idade(val) {
                    if (val === '') return true;
                    if (val.length === 10) {
                        return this.getIdade(val) >= this.idadeMinima;
                    }
                    return false;
                }
            },
            cep: {
                required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
                minLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(10),
                maxLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(10)
            },
            logradouro: {
                required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
            },
            numero: {
                required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
                maxLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(20)
            },
            complemento: {
                maxLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(40)
            },
            bairro: {
                required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
                maxLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(60)
            },
            cidade: {
                required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
                maxLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(50)
            },
            metadados: {
                camiseta: {
                    required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
                },
                categoria: {
                    required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
                },
                atleta2_nome: {
                    required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
                },
                atleta2_email: {
                    required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
                },
                atleta2_cpf: {
                    required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
                    cpf: validaCpf
                },
                atleta2_celular: {
                    required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
                    minLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(14)
                },
                atleta2_camiseta: {
                    required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
                }
            }
        }
    }
});

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 209,
	"./af.js": 209,
	"./ar": 210,
	"./ar-dz": 211,
	"./ar-dz.js": 211,
	"./ar-kw": 212,
	"./ar-kw.js": 212,
	"./ar-ly": 213,
	"./ar-ly.js": 213,
	"./ar-ma": 214,
	"./ar-ma.js": 214,
	"./ar-sa": 215,
	"./ar-sa.js": 215,
	"./ar-tn": 216,
	"./ar-tn.js": 216,
	"./ar.js": 210,
	"./az": 217,
	"./az.js": 217,
	"./be": 218,
	"./be.js": 218,
	"./bg": 219,
	"./bg.js": 219,
	"./bm": 220,
	"./bm.js": 220,
	"./bn": 221,
	"./bn-bd": 222,
	"./bn-bd.js": 222,
	"./bn.js": 221,
	"./bo": 223,
	"./bo.js": 223,
	"./br": 224,
	"./br.js": 224,
	"./bs": 225,
	"./bs.js": 225,
	"./ca": 226,
	"./ca.js": 226,
	"./cs": 227,
	"./cs.js": 227,
	"./cv": 228,
	"./cv.js": 228,
	"./cy": 229,
	"./cy.js": 229,
	"./da": 230,
	"./da.js": 230,
	"./de": 231,
	"./de-at": 232,
	"./de-at.js": 232,
	"./de-ch": 233,
	"./de-ch.js": 233,
	"./de.js": 231,
	"./dv": 234,
	"./dv.js": 234,
	"./el": 235,
	"./el.js": 235,
	"./en-au": 236,
	"./en-au.js": 236,
	"./en-ca": 237,
	"./en-ca.js": 237,
	"./en-gb": 238,
	"./en-gb.js": 238,
	"./en-ie": 239,
	"./en-ie.js": 239,
	"./en-il": 240,
	"./en-il.js": 240,
	"./en-in": 241,
	"./en-in.js": 241,
	"./en-nz": 242,
	"./en-nz.js": 242,
	"./en-sg": 243,
	"./en-sg.js": 243,
	"./eo": 244,
	"./eo.js": 244,
	"./es": 245,
	"./es-do": 246,
	"./es-do.js": 246,
	"./es-mx": 247,
	"./es-mx.js": 247,
	"./es-us": 248,
	"./es-us.js": 248,
	"./es.js": 245,
	"./et": 249,
	"./et.js": 249,
	"./eu": 250,
	"./eu.js": 250,
	"./fa": 251,
	"./fa.js": 251,
	"./fi": 252,
	"./fi.js": 252,
	"./fil": 253,
	"./fil.js": 253,
	"./fo": 254,
	"./fo.js": 254,
	"./fr": 255,
	"./fr-ca": 256,
	"./fr-ca.js": 256,
	"./fr-ch": 257,
	"./fr-ch.js": 257,
	"./fr.js": 255,
	"./fy": 258,
	"./fy.js": 258,
	"./ga": 259,
	"./ga.js": 259,
	"./gd": 260,
	"./gd.js": 260,
	"./gl": 261,
	"./gl.js": 261,
	"./gom-deva": 262,
	"./gom-deva.js": 262,
	"./gom-latn": 263,
	"./gom-latn.js": 263,
	"./gu": 264,
	"./gu.js": 264,
	"./he": 265,
	"./he.js": 265,
	"./hi": 266,
	"./hi.js": 266,
	"./hr": 267,
	"./hr.js": 267,
	"./hu": 268,
	"./hu.js": 268,
	"./hy-am": 269,
	"./hy-am.js": 269,
	"./id": 270,
	"./id.js": 270,
	"./is": 271,
	"./is.js": 271,
	"./it": 272,
	"./it-ch": 273,
	"./it-ch.js": 273,
	"./it.js": 272,
	"./ja": 274,
	"./ja.js": 274,
	"./jv": 275,
	"./jv.js": 275,
	"./ka": 276,
	"./ka.js": 276,
	"./kk": 277,
	"./kk.js": 277,
	"./km": 278,
	"./km.js": 278,
	"./kn": 279,
	"./kn.js": 279,
	"./ko": 280,
	"./ko.js": 280,
	"./ku": 281,
	"./ku.js": 281,
	"./ky": 282,
	"./ky.js": 282,
	"./lb": 283,
	"./lb.js": 283,
	"./lo": 284,
	"./lo.js": 284,
	"./lt": 285,
	"./lt.js": 285,
	"./lv": 286,
	"./lv.js": 286,
	"./me": 287,
	"./me.js": 287,
	"./mi": 288,
	"./mi.js": 288,
	"./mk": 289,
	"./mk.js": 289,
	"./ml": 290,
	"./ml.js": 290,
	"./mn": 291,
	"./mn.js": 291,
	"./mr": 292,
	"./mr.js": 292,
	"./ms": 293,
	"./ms-my": 294,
	"./ms-my.js": 294,
	"./ms.js": 293,
	"./mt": 295,
	"./mt.js": 295,
	"./my": 296,
	"./my.js": 296,
	"./nb": 297,
	"./nb.js": 297,
	"./ne": 298,
	"./ne.js": 298,
	"./nl": 299,
	"./nl-be": 300,
	"./nl-be.js": 300,
	"./nl.js": 299,
	"./nn": 301,
	"./nn.js": 301,
	"./oc-lnc": 302,
	"./oc-lnc.js": 302,
	"./pa-in": 303,
	"./pa-in.js": 303,
	"./pl": 304,
	"./pl.js": 304,
	"./pt": 305,
	"./pt-br": 306,
	"./pt-br.js": 306,
	"./pt.js": 305,
	"./ro": 307,
	"./ro.js": 307,
	"./ru": 308,
	"./ru.js": 308,
	"./sd": 309,
	"./sd.js": 309,
	"./se": 310,
	"./se.js": 310,
	"./si": 311,
	"./si.js": 311,
	"./sk": 312,
	"./sk.js": 312,
	"./sl": 313,
	"./sl.js": 313,
	"./sq": 314,
	"./sq.js": 314,
	"./sr": 315,
	"./sr-cyrl": 316,
	"./sr-cyrl.js": 316,
	"./sr.js": 315,
	"./ss": 317,
	"./ss.js": 317,
	"./sv": 318,
	"./sv.js": 318,
	"./sw": 319,
	"./sw.js": 319,
	"./ta": 320,
	"./ta.js": 320,
	"./te": 321,
	"./te.js": 321,
	"./tet": 322,
	"./tet.js": 322,
	"./tg": 323,
	"./tg.js": 323,
	"./th": 324,
	"./th.js": 324,
	"./tk": 325,
	"./tk.js": 325,
	"./tl-ph": 326,
	"./tl-ph.js": 326,
	"./tlh": 327,
	"./tlh.js": 327,
	"./tr": 328,
	"./tr.js": 328,
	"./tzl": 329,
	"./tzl.js": 329,
	"./tzm": 330,
	"./tzm-latn": 331,
	"./tzm-latn.js": 331,
	"./tzm.js": 330,
	"./ug-cn": 332,
	"./ug-cn.js": 332,
	"./uk": 333,
	"./uk.js": 333,
	"./ur": 334,
	"./ur.js": 334,
	"./uz": 335,
	"./uz-latn": 336,
	"./uz-latn.js": 336,
	"./uz.js": 335,
	"./vi": 337,
	"./vi.js": 337,
	"./x-pseudo": 338,
	"./x-pseudo.js": 338,
	"./yo": 339,
	"./yo.js": 339,
	"./zh-cn": 340,
	"./zh-cn.js": 340,
	"./zh-hk": 341,
	"./zh-hk.js": 341,
	"./zh-mo": 342,
	"./zh-mo.js": 342,
	"./zh-tw": 343,
	"./zh-tw.js": 343
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 716;

/***/ }),

/***/ 723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.ended)?_c('div',{staticClass:"row"},[_c('h2',[_vm._v("Inscrições encerradas.")]),_vm._v(" "),_vm._m(0)]):_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading"},[_vm._v("Formulário de inscrição")]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[(_vm.$store.state.loaded)?_c('form',[(_vm.errors)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",domProps:{"innerHTML":_vm._s(_vm.errors)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 has-required"},[_c('div',{staticClass:"checkbox"},[_c('label',{staticClass:"control-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.aceito),expression:"aceito"}],attrs:{"type":"checkbox","value":"1"},domProps:{"checked":Array.isArray(_vm.aceito)?_vm._i(_vm.aceito,"1")>-1:(_vm.aceito)},on:{"change":function($event){var $$a=_vm.aceito,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.aceito=$$a.concat([$$v]))}else{$$i>-1&&(_vm.aceito=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.aceito=$$c}}}}),_vm._v("\n                                         ACEITO as regras do FESTIVAL PÉ NA PRAIA – São Miguel do Gostoso, presentes no REGULAMENTO GERAL do evento e a política de tratamento de dados, nos limites das finalidades institucionais da H C PRODUÇÕES E EVENTOS LTDA - HC SPORTS, organizadora do evento, observando o norteamento jurídico da Lei 13.709/2018 (LGPD).\n                                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"3rem"}},[_c('div',{staticClass:"col-md-12 has-required"},[_c('div',{staticClass:"checkbox"},[_c('label',{staticClass:"control-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.aceitoVacina),expression:"aceitoVacina"}],attrs:{"type":"checkbox","value":"1"},domProps:{"checked":Array.isArray(_vm.aceitoVacina)?_vm._i(_vm.aceitoVacina,"1")>-1:(_vm.aceitoVacina)},on:{"change":function($event){var $$a=_vm.aceitoVacina,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.aceitoVacina=$$a.concat([$$v]))}else{$$i>-1&&(_vm.aceitoVacina=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.aceitoVacina=$$c}}}}),_vm._v("\n                                            Estou CIENTE que o FESTIVAL PÉ NA PRAIA – São Miguel do Gostoso é um evento EXCLUSIVO para vacinados contra a COVID-19 (exigência dos órgãos de saúde do RN). Sei também, que para validar a minha inscrição, preciso apresentar o meu CERTIFICADO DE VACINAÇÃO no ato da retirada do kit de participação. Ao realizar a inscrição no FESTIVAL PÉ NA PRAIA – São Miguel do Gostoso, CONCORDO com esta regra e tenho ciência que o descumprimento desta invalida o meu cadastro e a possibilidade de restituição do valor pago.\n                                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 has-required"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"categoria"}},[_vm._v("Categoria")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.inscricao.metadados.categoria),expression:"inscricao.metadados.categoria"}],staticClass:"form-control",attrs:{"id":"categoria"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.inscricao.metadados, "categoria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}}),_vm._v(" "),_vm._l((_vm.$store.state.inscricao.options.categoria),function(item,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v("\n                                        "+_vm._s(item)+"\n                                    ")])})],2)])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'nome')},[_c('label',{staticClass:"control-label",attrs:{"for":"nome"}},[_vm._v("Nome Completo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.nome),expression:"inscricao.nome",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"nome","maxlength":"50","required":"required"},domProps:{"value":(_vm.inscricao.nome)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao, "nome", $event.target.value.trim())},function($event){_vm.$v.inscricao.nome.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.inscricao.nome.$error && !_vm.$v.inscricao.nome.containsSpace)?_c('span',{staticClass:"help-block"},[_vm._v("Digite o seu nome completo.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'email')},[_c('label',{staticClass:"control-label",attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.email),expression:"inscricao.email",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"email","id":"email","maxlength":"60","required":"required"},domProps:{"value":(_vm.inscricao.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao, "email", $event.target.value.trim())},function($event){_vm.$v.inscricao.email.$touch()}],"blur":function($event){_vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'login')},[_c('label',{staticClass:"control-label",attrs:{"for":"login"}},[_vm._v("Nome de usuário")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.login),expression:"inscricao.login",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"login","required":"required"},domProps:{"value":(_vm.inscricao.login)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao, "login", $event.target.value.trim())},function($event){_vm.$v.inscricao.login.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("\n                                    Crie um nome de usuário. Exemplo: sou.tenista\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'senha')},[_c('label',{staticClass:"control-label",attrs:{"for":"senha"}},[_vm._v("Senha")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inscricao.senha),expression:"inscricao.senha"}],staticClass:"form-control",attrs:{"type":"password","id":"senha","required":"required"},domProps:{"value":(_vm.inscricao.senha)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao, "senha", $event.target.value)},function($event){_vm.$v.inscricao.senha.$touch()}]}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'confirma_senha')},[_c('label',{staticClass:"control-label",attrs:{"for":"confirma_senha"}},[_vm._v("Confirme a senha")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inscricao.confirma_senha),expression:"inscricao.confirma_senha"}],staticClass:"form-control",attrs:{"type":"password","id":"confirma_senha","required":"required"},domProps:{"value":(_vm.inscricao.confirma_senha)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao, "confirma_senha", $event.target.value)},function($event){_vm.$v.inscricao.confirma_senha.$touch()}]}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 has-required"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"documento_tipo"}},[_vm._v("Tipo de Documento")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.inscricao.documento_tipo),expression:"inscricao.documento_tipo"}],staticClass:"form-control",attrs:{"id":"documento_tipo"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.inscricao, "documento_tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"CPF"}},[_vm._v("CPF")]),_vm._v(" "),_c('option',{attrs:{"value":"Passaporte"}},[_vm._v("Passaporte")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'documento')},[_c('label',{staticClass:"control-label",attrs:{"for":"documento"}},[_vm._v(_vm._s(_vm.documentoLabel))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.documento),expression:"inscricao.documento",modifiers:{"trim":true}},{name:"mask",rawName:"v-mask",value:(_vm.documentoMask),expression:"documentoMask"}],staticClass:"form-control",attrs:{"type":"text","id":"documento","required":"required"},domProps:{"value":(_vm.inscricao.documento)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao, "documento", $event.target.value.trim())},function($event){_vm.setMaskedFieldState(_vm.$v, 'documento')}],"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'nascimento')},[_c('label',{staticClass:"control-label",attrs:{"for":"nascimento"}},[_vm._v("\n                                    Data de Nascimento\n                                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.nascimento),expression:"inscricao.nascimento",modifiers:{"trim":true}},{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],staticClass:"form-control",attrs:{"type":"text","id":"nascimento","placeholder":"dia/mês/ano","required":"required"},domProps:{"value":(_vm.inscricao.nascimento)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao, "nascimento", $event.target.value.trim())},function($event){_vm.$v.inscricao.nascimento.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.inscricao.nascimento.$error && !_vm.$v.inscricao.nascimento.idade)?_c('span',{staticClass:"help-block"},[_vm._v("\n                                    Idade mínima: "+_vm._s(_vm.idadeMinima)+"\n                                ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'telefone')},[_c('label',{staticClass:"control-label",attrs:{"for":"telefone"}},[_vm._v("Telefone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.telefone),expression:"inscricao.telefone",modifiers:{"trim":true}},{name:"mask",rawName:"v-mask",value:(_vm.telefoneMask),expression:"telefoneMask"}],staticClass:"form-control",attrs:{"type":"text","id":"telefone"},domProps:{"value":(_vm.inscricao.telefone)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao, "telefone", $event.target.value.trim())},function($event){_vm.setMaskedFieldState(_vm.$v, 'telefone')}],"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'celular')},[_c('label',{staticClass:"control-label",attrs:{"for":"celular"}},[_vm._v("Celular")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.celular),expression:"inscricao.celular",modifiers:{"trim":true}},{name:"mask",rawName:"v-mask",value:(_vm.celularMask),expression:"celularMask"}],staticClass:"form-control",attrs:{"type":"text","id":"celular","required":"required"},domProps:{"value":(_vm.inscricao.celular)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao, "celular", $event.target.value.trim())},function($event){_vm.setMaskedFieldState(_vm.$v, 'celular')}],"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'cep')},[_c('label',{staticClass:"control-label",attrs:{"for":"cep"}},[_vm._v("CEP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.cep),expression:"inscricao.cep",modifiers:{"trim":true}},{name:"mask",rawName:"v-mask",value:('##.###-###'),expression:"'##.###-###'"}],staticClass:"form-control",attrs:{"type":"text","id":"cep","required":"required"},domProps:{"value":(_vm.inscricao.cep)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao, "cep", $event.target.value.trim())},function($event){_vm.$v.inscricao.cep.$touch()}],"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"container--overlay",attrs:{"id":"container-endereco"}},[_c('div',{staticClass:"overlay",class:{shown: _vm.loadingCep},attrs:{"id":"cep-overlay"}},[_c('img',{attrs:{"src":__webpack_require__(724)}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'logradouro')},[_c('label',{staticClass:"control-label",attrs:{"for":"logradouro"}},[_vm._v("Logradouro")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.logradouro),expression:"inscricao.logradouro",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"logradouro","required":"required"},domProps:{"value":(_vm.inscricao.logradouro)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao, "logradouro", $event.target.value.trim())},function($event){_vm.$v.inscricao.logradouro.$touch()}],"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'numero')},[_c('label',{staticClass:"control-label",attrs:{"for":"nome"}},[_vm._v("Número")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.numero),expression:"inscricao.numero",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"numero","maxlength":"20","required":"required"},domProps:{"value":(_vm.inscricao.numero)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao, "numero", $event.target.value.trim())},function($event){_vm.$v.inscricao.numero.$touch()}],"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'complemento')},[_c('label',{staticClass:"control-label",attrs:{"for":"complemento"}},[_vm._v("Complemento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.complemento),expression:"inscricao.complemento",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"complemento","maxlength":"40"},domProps:{"value":(_vm.inscricao.complemento)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao, "complemento", $event.target.value.trim())},function($event){_vm.$v.inscricao.complemento.$touch()}],"blur":function($event){_vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'bairro')},[_c('label',{staticClass:"control-label",attrs:{"for":"bairro"}},[_vm._v("Bairro")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.bairro),expression:"inscricao.bairro",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"bairro","maxlength":"60","required":"required"},domProps:{"value":(_vm.inscricao.bairro)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao, "bairro", $event.target.value.trim())},function($event){_vm.$v.inscricao.bairro.$touch()}],"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'cidade')},[_c('label',{staticClass:"control-label",attrs:{"for":"cidade"}},[_vm._v("Cidade")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.cidade),expression:"inscricao.cidade",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"cidade","maxlength":"50","required":"required"},domProps:{"value":(_vm.inscricao.cidade)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao, "cidade", $event.target.value.trim())},function($event){_vm.$v.inscricao.cidade.$touch()}],"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 has-required"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"uf"}},[_vm._v("UF")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.inscricao.uf),expression:"inscricao.uf"}],staticClass:"form-control",attrs:{"id":"uf"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.inscricao, "uf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"AC","selected":"selected"}},[_vm._v("Acre")]),_vm._v(" "),_c('option',{attrs:{"value":"AL"}},[_vm._v("Alagoas")]),_vm._v(" "),_c('option',{attrs:{"value":"AM"}},[_vm._v("Amazonas")]),_vm._v(" "),_c('option',{attrs:{"value":"AP"}},[_vm._v("Amapá")]),_vm._v(" "),_c('option',{attrs:{"value":"BA"}},[_vm._v("Bahia")]),_vm._v(" "),_c('option',{attrs:{"value":"CE"}},[_vm._v("Ceará")]),_vm._v(" "),_c('option',{attrs:{"value":"DF"}},[_vm._v("Distrito Federal")]),_vm._v(" "),_c('option',{attrs:{"value":"ES"}},[_vm._v("Espírito Santo")]),_vm._v(" "),_c('option',{attrs:{"value":"GO"}},[_vm._v("Goiás")]),_vm._v(" "),_c('option',{attrs:{"value":"MA"}},[_vm._v("Maranhão")]),_vm._v(" "),_c('option',{attrs:{"value":"MT"}},[_vm._v("Mato Grosso")]),_vm._v(" "),_c('option',{attrs:{"value":"MS"}},[_vm._v("Mato Grosso do Sul")]),_vm._v(" "),_c('option',{attrs:{"value":"MG"}},[_vm._v("Minas Gerais")]),_vm._v(" "),_c('option',{attrs:{"value":"PA"}},[_vm._v("Pará")]),_vm._v(" "),_c('option',{attrs:{"value":"PB"}},[_vm._v("Paraíba")]),_vm._v(" "),_c('option',{attrs:{"value":"PR"}},[_vm._v("Paraná")]),_vm._v(" "),_c('option',{attrs:{"value":"PE"}},[_vm._v("Pernambuco")]),_vm._v(" "),_c('option',{attrs:{"value":"PI"}},[_vm._v("Piauí")]),_vm._v(" "),_c('option',{attrs:{"value":"RJ"}},[_vm._v("Rio de Janeiro")]),_vm._v(" "),_c('option',{attrs:{"value":"RN"}},[_vm._v("Rio Grande do Norte")]),_vm._v(" "),_c('option',{attrs:{"value":"RO"}},[_vm._v("Rondônia")]),_vm._v(" "),_c('option',{attrs:{"value":"RS"}},[_vm._v("Rio Grande do Sul")]),_vm._v(" "),_c('option',{attrs:{"value":"RR"}},[_vm._v("Roraima")]),_vm._v(" "),_c('option',{attrs:{"value":"SC"}},[_vm._v("Santa Catarina")]),_vm._v(" "),_c('option',{attrs:{"value":"SE"}},[_vm._v("Sergipe")]),_vm._v(" "),_c('option',{attrs:{"value":"SP"}},[_vm._v("São Paulo")]),_vm._v(" "),_c('option',{attrs:{"value":"TO"}},[_vm._v("Tocantins")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 has-required"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"distancia"}},[_vm._v("Camiseta")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.inscricao.metadados.camiseta),expression:"inscricao.metadados.camiseta"}],staticClass:"form-control",attrs:{"id":"camiseta"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.inscricao.metadados, "camiseta", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.$v.inscricao.metadados.camiseta.$touch()}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Escolha um tamanho de camiseta")]),_vm._v(" "),_vm._l((_vm.$store.state.inscricao.options.camiseta),function(item,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v("\n                                        "+_vm._s(item)+"\n                                    ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"equipe"}},[_vm._v("Equipe")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.metadados.equipe),expression:"inscricao.metadados.equipe",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"equipe"},domProps:{"value":(_vm.inscricao.metadados.equipe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao.metadados, "equipe", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'metadados.atleta2_nome')},[_c('label',{staticClass:"control-label",attrs:{"for":"atleta2_nome"}},[_vm._v("Nome Completo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.metadados.atleta2_nome),expression:"inscricao.metadados.atleta2_nome",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"atleta2_nome","maxlength":"50","required":"required"},domProps:{"value":(_vm.inscricao.metadados.atleta2_nome)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao.metadados, "atleta2_nome", $event.target.value.trim())},function($event){_vm.$v.inscricao.metadados.atleta2_nome.$touch()}],"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'metadados.atleta2_cpf')},[_c('label',{staticClass:"control-label",attrs:{"for":"atleta2_cpf"}},[_vm._v("CPF")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.metadados.atleta2_cpf),expression:"inscricao.metadados.atleta2_cpf",modifiers:{"trim":true}},{name:"mask",rawName:"v-mask",value:(_vm.maskCpf),expression:"maskCpf"}],staticClass:"form-control",attrs:{"type":"text","id":"atleta2_cpf","required":"required"},domProps:{"value":(_vm.inscricao.metadados.atleta2_cpf)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao.metadados, "atleta2_cpf", $event.target.value.trim())},function($event){_vm.$v.inscricao.metadados.atleta2_cpf.$touch()}],"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'metadados.atleta2_email')},[_c('label',{staticClass:"control-label",attrs:{"for":"atleta2_email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.metadados.atleta2_email),expression:"inscricao.metadados.atleta2_email",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"atleta2_email","required":"required"},domProps:{"value":(_vm.inscricao.metadados.atleta2_email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao.metadados, "atleta2_email", $event.target.value.trim())},function($event){_vm.$v.inscricao.metadados.atleta2_email.$touch()}],"blur":function($event){_vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 has-required"},[_c('div',{staticClass:"form-group",class:_vm.formGroupClass(_vm.$v, 'metadados.atleta2_celular')},[_c('label',{staticClass:"control-label",attrs:{"for":"celular"}},[_vm._v("Celular")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inscricao.metadados.atleta2_celular),expression:"inscricao.metadados.atleta2_celular",modifiers:{"trim":true}},{name:"mask",rawName:"v-mask",value:(_vm.fixedCelularMask),expression:"fixedCelularMask"}],staticClass:"form-control",attrs:{"type":"text","id":"atleta2_celular","required":"required"},domProps:{"value":(_vm.inscricao.metadados.atleta2_celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inscricao.metadados, "atleta2_celular", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 has-required"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"atleta2_camiseta"}},[_vm._v("Camiseta")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.inscricao.metadados.atleta2_camiseta),expression:"inscricao.metadados.atleta2_camiseta"}],staticClass:"form-control",attrs:{"id":"atleta2_camiseta"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.inscricao.metadados, "atleta2_camiseta", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Escolha um tamanho de camiseta")]),_vm._v(" "),_vm._l((_vm.$store.state.inscricao.options.camiseta),function(item,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v("\n                                        "+_vm._s(item)+"\n                                    ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group text-right"},[_c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"submit","disabled":_vm.$v.$invalid || _vm.sending},on:{"click":_vm.inscricaoSave}},[_c('span',{staticClass:"glyphicon glyphicon-ok"}),_vm._v(" Enviar\n                                ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.$v.$invalid || !_vm.aceito),expression:"$v.$invalid || !aceito"}],staticClass:"help-block"},[_vm._v("É preciso preencher o formulário corretamente e aceitar o regulamento para efetuar a inscrição.")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.sending),expression:"sending"}],staticClass:"help-block"},[_vm._v("Processando, por favor aguarde...")])])])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Maiores informações: "),_c('a',{attrs:{"href":"mailto:contato@hcsports.com.br"}},[_vm._v("contato@hcsports.com.br")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h3',[_vm._v("Atleta 1")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"form-control form-control--text-only",attrs:{"id":"loading"}},[_c('em',[_vm._v("Informe o CEP para\n                                    preencher o endereço automaticamente.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h3',[_vm._v("Atleta 2")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 725:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Painel_vue__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5778aac4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Painel_vue__ = __webpack_require__(733);
var normalizeComponent = __webpack_require__(38)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Painel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5778aac4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Painel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 726:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Inscricao__ = __webpack_require__(179);






var numeral = __webpack_require__(344);
var moment = __webpack_require__(0);
__webpack_require__(727);
moment.locale('pt-BR');

__webpack_require__(732);

numeral.locale('pt-br');

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Inscricao: __WEBPACK_IMPORTED_MODULE_2__Inscricao__["a" /* default */]
    },
    data: function data() {
        return {
            sending: false,
            completed: false,
            user: null,
            inscricaoInCart: false,
            extraData: {
                voucher: null
            },
            editing: false
        };
    },

    computed: {
        total: function total() {
            var total = 0;
            for (var i in this.$store.state.cart) {
                total += this.$store.state.cart[i]['price'];
            }
            return this.formatCurrency(total);
        }
    },
    methods: {
        editForm: function editForm() {
            this.editing = true;
        },
        editBack: function editBack() {
            this.editing = false;
        },
        addInscricaoToCart: function addInscricaoToCart() {
            for (var i in this.$store.state.requiredProducts) {
                this.$store.commit('addToCart', this.$store.state.requiredProducts[i]);
            }
            this.inscricaoInCart = true;
        },
        removeInscricaoFromCart: function removeInscricaoFromCart(produto) {
            this.$store.commit('removeFromCart', produto);
            this.inscricaoInCart = false;
        },
        cartRemovalPossible: function cartRemovalPossible(produto) {
            if (produto.required && !this.$store.state.inscricaoIniciada) {
                return false;
            }
            return true;
        },
        paymentRequest: function paymentRequest() {
            var bearerToken = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('bearer');
            var diz = this;
            this.sending = true;
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
                url: "https://inscricoes.horadecorrer.com/frontend/payment",
                method: 'POST',
                data: { 'cart': { 0: { 'id': 'inscricao', 'quantity': 1 } }, 'extraData': diz.extraData },
                success: function success(data, textStatus, jqXHR) {
                    if (data.ok) {
                        diz.completed = true;
                        if (typeof data.url !== 'undefined') {
                            window.location.href = data.url;
                        }
                        if (typeof data.status !== 'undefined') {
                            var text = 'Sua inscrição foi realizada com sucesso';
                            if (diz.extraData.voucher) {
                                text = 'Seu código promocional foi aceito';
                            }
                            swal({
                                title: 'Sucesso!',
                                text: text,
                                type: 'success'
                            }, function () {
                                window.location.reload();
                            });
                        }
                    }
                },
                error: function error(data, textStatus, jqXHR) {
                    diz.completed = false;
                    toastr.error(data.responseJSON.message);
                },
                complete: function complete(data, textStatus, jqXHR) {
                    diz.sending = false;
                },
                headers: {
                    'Authorization': 'Bearer ' + bearerToken
                },
                dataType: 'JSON'
            });
        },
        formatDate: function formatDate(val) {
            return moment(val, 'YYYY-MM-DD').format('L');
        },
        formatDateTime: function formatDateTime(val) {
            return moment(val, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss');
        },
        formatCurrency: function formatCurrency(val) {
            return numeral(val).format('$0,0.00');
        }
    },
    watch: {
        'extraData.voucher': function extraDataVoucher(val) {
            this.extraData.voucher = val.toUpperCase().replace('  ', ' ');
        }
    },
    validations: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(53)))

/***/ }),

/***/ 733:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"small text-right painel__main-info"},[_c('div',{staticClass:"nome"},[_vm._v(_vm._s(_vm.$store.state.user.nome)+" ("+_vm._s(_vm.$store.state.user.login)+")")]),_vm._v(" "),_c('span',{staticClass:"main-info__label"},[_vm._v("Status da inscrição:")]),_vm._v("\n            "+_vm._s(_vm.$store.state.inscricao.options.status[_vm.$store.state.user.status])+"\n        ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"role":"tabpanel","id":"inscricao"}},[(_vm.$store.state.inscricaoOk)?_c('div',[_c('p',{staticClass:"alert alert-success"},[_vm._v("Sua inscrição já foi confirmada!")])]):_c('div',[(_vm.$store.state.inscricaoIniciada && !_vm.inscricaoInCart)?_c('div',[_c('p',{staticClass:"alert alert-info"},[_vm._v("Você já iniciou um pagamento para a sua inscrição.")]),_vm._v(" "),_c('a',{staticClass:"btn btn-lg btn-success",attrs:{"href":"javascript:document.getElementById('comprasTab').click()"}},[_vm._v("Clique aqui para visualizar suas compras.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"well"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.addInscricaoToCart()}}},[_vm._v("REFAZER PAGAMENTO\n                            ")])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"role":"tabpanel","id":"compras"}},[(_vm.$store.state.compras.length)?_c('table',{staticClass:"table table-striped table-bordered"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.$store.state.compras),function(compra){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.formatDateTime(compra.data)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(compra.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatCurrency(compra.price)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(compra.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(compra.status))])])}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"role":"tabpanel","id":"dados"}},[_c('table',{staticClass:"table table-striped table-bordered"},[_c('tbody',[(_vm.editing)?[_c('inscricao',{attrs:{"edit-mode":"true"}})]:[_c('tr',[_c('th',[_vm._v("Nome completo")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.nome))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Email")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.email))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Nome de usuário")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.login))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Tipo de documento")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.documento_tipo))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Documento")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.documento))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Data de nascimento")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(_vm.$store.state.user.nascimento)))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Telefone")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.telefone))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Celular")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.celular))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("CEP")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.cep))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Logradouro")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.logradouro))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Número")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.numero))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Complemento")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.complemento))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Bairro")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.bairro))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Cidade")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.cidade))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("UF")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.uf))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Camiseta")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.metadados.camiseta))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Equipe")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.metadados.equipe))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Categoria")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.state.user.metadados.categoria))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Atleta 2")]),_vm._v(" "),_c('td',[_c('ul',[_c('li',[_vm._v("Nome: "+_vm._s(_vm.$store.state.user.metadados.atleta2_nome))]),_vm._v(" "),_c('li',[_vm._v("CPF: "+_vm._s(_vm.$store.state.user.metadados.atleta2_cpf))]),_vm._v(" "),_c('li',[_vm._v("Email: "+_vm._s(_vm.$store.state.user.metadados.atleta2_email))]),_vm._v(" "),_c('li',[_vm._v("Celular: "+_vm._s(_vm.$store.state.user.metadados.atleta2_celular))]),_vm._v(" "),_c('li',[_vm._v("Camiseta: "+_vm._s(_vm.$store.state.user.metadados.atleta2_camiseta))])])])])],_vm._v(" "),(_vm.editing)?_c('tr',[_vm._m(3)]):_vm._e()],2)])])]),_vm._v(" "),(_vm.$store.state.cart.length)?_c('div',{staticClass:"panel panel-success"},[_c('div',{staticClass:"panel-heading"},[_vm._v("\n                Carrinho\n            ")]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('table',{staticClass:"table table-striped table-condensed"},[_vm._m(4),_vm._v(" "),_c('tfoot',[_c('tr',{staticClass:"text-right"},[_c('td',{staticClass:"text-right row--total",attrs:{"colspan":"5"}},[_vm._v("\n                            TOTAL: "+_vm._s(_vm.total)+"\n                        ")])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"5"}},[_c('div',{staticClass:"text-right form-inline"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"voucher"}},[_vm._v("Informe o seu código promocional, caso possua um:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraData.voucher),expression:"extraData.voucher"}],staticClass:"form-control input-lg",attrs:{"type":"text","id":"voucher"},domProps:{"value":(_vm.extraData.voucher)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraData, "voucher", $event.target.value)}}})])])])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"5"}},[_c('div',{staticClass:"text-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.completed),expression:"!completed"}],staticClass:"btn btn-lg btn-success",attrs:{"type":"button","disabled":_vm.sending},on:{"click":_vm.paymentRequest}},[_vm._v("EFETUAR PAGAMENTO\n                                ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.sending),expression:"sending"}],staticClass:"help-block"},[_vm._v("Processando, por favor aguarde...")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.completed),expression:"completed"}],staticClass:"help-block"},[_vm._v("Concluído! Redirecionando para o PagSeguro...")])])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.$store.state.cart),function(produto){return _c('tr',[_c('td',[_vm._v(_vm._s(produto.name))]),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(produto.description)}}),_vm._v(" "),_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatCurrency(produto.price)))]),_vm._v(" "),_c('td',[(_vm.cartRemovalPossible(produto))?_c('div',{staticClass:"btn-group btn-group-sm"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){_vm.removeInscricaoFromCart(produto)}}},[_vm._v("\n                                    Remover\n                                ")])]):_c('div',[_vm._v("\n                                 \n                            ")])])])}))])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs",attrs:{"role":"tablist"}},[_c('li',{staticClass:"active",attrs:{"role":"presentation"}},[_c('a',{attrs:{"href":"#inscricao","aria-controls":"inscricao","role":"tab","data-toggle":"tab"}},[_vm._v("Inscrição")])]),_vm._v(" "),_c('li',{attrs:{"role":"presentation"}},[_c('a',{attrs:{"id":"comprasTab","href":"#compras","aria-controls":"compras","role":"tab","data-toggle":"tab"}},[_vm._v("Suas compras")])]),_vm._v(" "),_c('li',{attrs:{"role":"presentation"}},[_c('a',{attrs:{"href":"#dados","aria-controls":"dados","role":"tab","data-toggle":"tab"}},[_vm._v("Seus dados")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Para fazer uma nova tentativa de pagamento, utilize o botão abaixo.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Produto")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th',[_vm._v("Quantidade")]),_vm._v(" "),_c('th',[_vm._v("Status")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticStyle:{"text-align":"right"},attrs:{"colspan":"2"}},[_c('a',{staticClass:"btn btn-success btn-sm",attrs:{"onclick":""}},[_vm._v("Salvar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Produto")]),_vm._v(" "),_c('th',[_vm._v("Observação")]),_vm._v(" "),_c('th',[_vm._v("Quantidade")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Valor")]),_vm._v(" "),_c('th',[_vm._v(" ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 734:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.loaded)?_c('div',[(_vm.$store.state.loggedIn)?_c('div',[_c('painel')],1):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$store.state.evento.descricao)}}),_vm._v(" "),_c('inscricao')],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 735:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_553f63d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(738);
function injectStyle (ssrContext) {
  __webpack_require__(736)
}
var normalizeComponent = __webpack_require__(38)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_553f63d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 736:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 737:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);




var slugify = __webpack_require__(95);

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            login: null,
            senha: null
        };
    },
    methods: {
        submit: function submit(evt) {
            evt.preventDefault();
            var diz = this;
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
                url: "https://inscricoes.horadecorrer.com/oauth2/token",
                method: 'POST',
                data: {
                    grant_type: 'password',
                    username: this.login,
                    password: this.senha,
                    evento_id: 26,
                    client_id: 'hcinscricoes',
                    client_secret: 'hcinscricoes'
                },
                success: function success(data, textStatus, jqXHR) {
                    diz.$store.dispatch('login', { token: data.access_token }).then(function (data, textStatus, jqXHR) {
                        diz.$store.commit('assignInfo', data);
                    });
                    __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.success('Bem-vindo!');
                    diz.$router.push('/');
                },
                error: function error(data, textStatus, jqXHR) {
                    __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.error('Usuário e/ou senha inválidos');
                }
            });
        }
    },
    watch: {
        'login': function login(val) {
            this.login = slugify(val.toLowerCase(), '.').replace('..', '.');
        }
    }
});

/***/ }),

/***/ 738:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-md-offset-3"},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading"},[_vm._v("Identificação")]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"login"}},[_vm._v("Usuário")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login),expression:"login"}],staticClass:"form-control",attrs:{"type":"text","id":"login","placeholder":"Usuário"},domProps:{"value":(_vm.login)},on:{"input":function($event){if($event.target.composing){ return; }_vm.login=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"senha"}},[_vm._v("Senha")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.senha),expression:"senha"}],staticClass:"form-control",attrs:{"type":"password","id":"senha","placeholder":"Senha"},domProps:{"value":(_vm.senha)},on:{"input":function($event){if($event.target.composing){ return; }_vm.senha=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-sm-offset-2 col-sm-10"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("Login")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"2rem"}},[_c('router-link',{attrs:{"to":"/senha"}},[_vm._v("Clique aqui caso tenha perdido sua senha")])],1)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 739:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Senha_vue__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_779b7e78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Senha_vue__ = __webpack_require__(742);
function injectStyle (ssrContext) {
  __webpack_require__(740)
}
var normalizeComponent = __webpack_require__(38)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Senha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_779b7e78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Senha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 740:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 741:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);




var slugify = __webpack_require__(95);

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            account: null,
            sending: false
        };
    },
    methods: {
        submit: function submit(evt) {
            var _this = this;

            evt.preventDefault();
            var diz = this;
            this.sending = true;
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
                url: "https://inscricoes.horadecorrer.com/site/senha",
                method: 'POST',
                data: {
                    account: this.account,
                    evento_id: this.$store.state.evento_id
                },
                success: function success(data, textStatus, jqXHR) {
                    __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.success('Verifique o seu email (' + _this.account + ') para obter o link de recriação de senha.');
                    diz.$router.push('/');
                },
                error: function error(jqXHR, textStatus, errorThrown) {
                    __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.error(errorThrown);
                },
                complete: function complete() {
                    _this.sending = false;
                }
            });
        }
    },
    watch: {
        'login': function login(val) {
            this.login = slugify(val.toLowerCase(), '.').replace('..', '.');
        }
    }
});

/***/ }),

/***/ 742:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-md-offset-4"},[_c('div',{staticClass:"panel panel-info"},[_c('div',{staticClass:"panel-heading"},[_vm._v("Informe seu email cadastrado no sistema")]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"account"}},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account),expression:"account"}],staticClass:"form-control",attrs:{"type":"email","id":"account","placeholder":"Email"},domProps:{"value":(_vm.account)},on:{"input":function($event){if($event.target.composing){ return; }_vm.account=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-sm-offset-2 col-sm-10"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit","disabled":_vm.sending},on:{"click":_vm.submit}},[_vm._v("OK")]),_vm._v(" "),(_vm.sending)?[_c('p',{staticClass:"help-block"},[_vm._v("Por favor aguarde aproximadamente 1 minuto.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"help-block"},[_vm._v("A página recarregará automaticamente no fim do processo.")])]:_vm._e(),_vm._v(" "),(!_vm.sending)?_c('div',{staticStyle:{"margin-top":"2rem"}},[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Voltar")])],1):_vm._e()],2)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"help-block"},[_vm._v("Sua solicitação está sendo processada. "),_c('span',{staticClass:"glyphicon glyphicon-repeat fast-right-spinner"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NovaSenha_vue__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01811e78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NovaSenha_vue__ = __webpack_require__(746);
function injectStyle (ssrContext) {
  __webpack_require__(744)
}
var normalizeComponent = __webpack_require__(38)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NovaSenha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01811e78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NovaSenha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 744:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 745:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);






var slugify = __webpack_require__(95);

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            nome: null,
            senha: null,
            confirma_senha: null
        };
    },
    mounted: function mounted() {
        var diz = this;
        var email = this.$route.params.email;
        var token = this.$route.params.token;
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
            url: "https://inscricoes.horadecorrer.com/site/novasenha",
            method: 'POST',
            data: {
                email: email,
                token: token,
                evento_id: this.$store.state.evento_id
            },
            success: function success(data, textStatus, jqXHR) {
                diz.nome = data.nome;
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.error(errorThrown);
                diz.$router.push('/');
            },
            dataType: 'JSON'
        });
    },
    methods: {
        submit: function submit(evt) {
            evt.preventDefault();
            var diz = this;
            var email = this.$route.params.email;
            var token = this.$route.params.token;
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
                url: "https://inscricoes.horadecorrer.com/site/novasenha",
                method: 'POST',
                data: {
                    senha: this.senha,
                    email: email,
                    token: token,
                    evento_id: this.$store.state.evento_id
                },
                dataType: 'JSON',
                success: function success(data, textStatus, jqXHR) {
                    __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.success('Sua senha foi alterada com sucesso.');
                    diz.$store.dispatch('login', { token: data.access_token }).then(function (data, textStatus, jqXHR) {
                        diz.$store.commit('assignInfo', data);
                    });
                    __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.success('Bem-vindo!');
                    diz.$router.push('/');
                },
                error: function error(jqXHR, textStatus, errorThrown) {
                    __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.error(errorThrown);
                }
            });
        }
    },
    watch: {
        'login': function login(val) {
            this.login = slugify(val.toLowerCase(), '.').replace('..', '.');
        }
    },
    validations: {
        senha: {
            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(4)
        },
        confirma_senha: {
            sameAs: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["sameAs"])('senha')
        }
    }
});

/***/ }),

/***/ 746:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-md-offset-4"},[_c('div',{staticClass:"panel panel-info"},[_c('div',{staticClass:"panel-heading"},[_vm._v("\n                Recriação de senha\n            ")]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[(_vm.nome)?_c('div',[_c('p',{staticStyle:{"font-size":"2rem","text-align":"center","margin-bottom":"2rem"}},[_vm._v(_vm._s(_vm.nome)+", informe uma nova senha de acesso.")])]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group has-required"},[_c('label',{staticClass:"col-sm-4 control-label",attrs:{"for":"senha"}},[_vm._v("Nova senha")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.senha),expression:"senha"}],staticClass:"form-control",attrs:{"type":"password","id":"senha","required":"required","placeholder":"Nova senha"},domProps:{"value":(_vm.senha)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.senha=$event.target.value},function($event){_vm.$v.senha.$touch()}]}})])]),_vm._v(" "),_c('div',{staticClass:"form-group has-required"},[_c('label',{staticClass:"col-sm-4 control-label",attrs:{"for":"confirma_senha"}},[_vm._v("Confirme a senha")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirma_senha),expression:"confirma_senha"}],staticClass:"form-control",attrs:{"type":"password","id":"confirma_senha","required":"required","placeholder":"Confirme a senha"},domProps:{"value":(_vm.confirma_senha)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.confirma_senha=$event.target.value},function($event){_vm.$v.confirma_senha.$touch()}]}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-sm-offset-4 col-sm-8"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.$v.$invalid),expression:"$v.$invalid"}],staticClass:"help-block"},[_vm._v("Preencha os campos de senha com o mesmo valor. A senha precisa ter pelo menos 4 caracteres.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit","disabled":_vm.$v.$invalid},on:{"click":_vm.submit}},[_vm._v("Salvar\n                            ")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"2rem"}},[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Voltar")])],1)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[348]);


// WEBPACK FOOTER //
// static/js/app.219aa48ed6915f2a77fa.js